import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=1067b3b2&scoped=true"
import script from "./LinkBlock.vue?vue&type=script&lang=js"
export * from "./LinkBlock.vue?vue&type=script&lang=js"
import style0 from "./LinkBlock.vue?vue&type=style&index=0&id=1067b3b2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067b3b2",
  null
  
)

export default component.exports